import { render, staticRenderFns } from "./PatientProfileMenu.vue?vue&type=template&id=5fb68907&scoped=true&"
import script from "./PatientProfileMenu.vue?vue&type=script&lang=ts&"
export * from "./PatientProfileMenu.vue?vue&type=script&lang=ts&"
import style0 from "./PatientProfileMenu.vue?vue&type=style&index=0&id=5fb68907&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb68907",
  null
  
)

export default component.exports